var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"text-align":"center"}},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }